// dataService.js - Livreur Zones
import api from '../../utils/ApiConfig';

// Fetch all zones
const fetchAllZones = async () => {
  try {
    const response = await api.get('/zones');
    return response.data;
  } catch (error) {
    console.error('Error fetching zones:', error);
    throw error;
  }
};

// Fetch all livreurs
const fetchAllLivreurs = async () => {
  try {
    // Fetch with a large per_page to get all livreurs (or use 9999)
    const response = await api.get('/users/role/3?per_page=9999'); // role 3 = livreur
    return response.data;
  } catch (error) {
    console.error('Error fetching livreurs:', error);
    throw error;
  }
};

// Fetch zones assigned to a livreur
const fetchLivreurZones = async (livreurId) => {
  try {
    const response = await api.get(`/livreurs/${livreurId}/zones`);
    return response.data;
  } catch (error) {
    console.error('Error fetching livreur zones:', error);
    throw error;
  }
};

// Fetch livreurs assigned to a zone
const fetchZoneLivreurs = async (zoneId) => {
  try {
    const response = await api.get(`/zones/${zoneId}/livreurs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching zone livreurs:', error);
    throw error;
  }
};

// Assign a zone to a livreur
const assignZoneToLivreur = async (livreurId, zoneData) => {
  try {
    const response = await api.post(`/livreurs/${livreurId}/zones`, zoneData);
    if (response.status === 201) {
      return response.data;
    } else {
      throw new Error(`Failed to assign zone. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error assigning zone:', error);
    throw error;
  }
};

// Bulk assign zones to a livreur
const bulkAssignZones = async (livreurId, zonesData) => {
  try {
    const response = await api.post(`/livreurs/${livreurId}/zones/bulk`, zonesData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to bulk assign zones. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error bulk assigning zones:', error);
    throw error;
  }
};

// Update zone assignment
const updateZoneAssignment = async (assignmentId, updateData) => {
  try {
    const response = await api.put(`/livreur-zones/${assignmentId}`, updateData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to update assignment. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error updating zone assignment:', error);
    throw error;
  }
};

// Delete zone assignment
const deleteZoneAssignment = async (assignmentId) => {
  try {
    const response = await api.delete(`/livreur-zones/${assignmentId}`);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to delete assignment. Status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error deleting zone assignment:', error);
    throw error;
  }
};

// Fetch available livreurs for a zone on a specific date
const fetchAvailableLivreursForZone = async (zoneId, date) => {
  try {
    const response = await api.get(`/zones/${zoneId}/available-livreurs?date=${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching available livreurs for zone:', error);
    throw error;
  }
};

// Fetch zone stats
const fetchZoneStats = async () => {
  try {
    const response = await api.get('/zones/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching zone stats:', error);
    throw error;
  }
};

// Export methods
export {
  fetchAllZones,
  fetchAllLivreurs,
  fetchLivreurZones,
  fetchZoneLivreurs,
  assignZoneToLivreur,
  bulkAssignZones,
  updateZoneAssignment,
  deleteZoneAssignment,
  fetchAvailableLivreursForZone,
  fetchZoneStats,
};
